<template>
  <b-modal
    @show="onShow"
    dialog-class="modal-dialog2"
    contentClass="md-confirm-content"
    :hideHeader= "true"
    bodyClass= "confirm-body"
    footerClass= "confirm-footer"
    :okTitle= "$t('common.ok')"
    :cancelTitle= "$t('common.cancel1')"
    okVariant= "primary md_btn_primary"
    cancelVariant= "secondary md_btn_light"
    centered
    :visible="visible"
    @ok="onOk"
    @hidden="onCancel"
  >
<!--    <p class="dlg_title" style="margin-bottom: 5px;">-->
    <p v-if="site_name != '' && site_name != undefined" class="dlg_title2" style="margin-bottom: 5px;">
      {{site_name}}
    </p>
    <p v-if="address != '' && address != undefined" class="sale_address2">
<!--    <p class="sale_address">-->
      <b-img :src="require('../../../assets/image/ic_address_detail@2x.png')" style="height: 20px; margin-left: 7px; vertical-align: text-bottom;"/>
      {{address}}
    </p>
    <div style="margin: 25px;">
      <div class="buttons">
        <b-button
          @click="setReportType('SC')" variant="white"
          :class="['btn btn_wide', this.report_type == 'SC'?'dark_blue':'']"
        >{{$t('site_report.site_completion')}}</b-button>
        <b-button
          @click="setReportType('SS')" variant="white"
          class="ml-4"
          :class="['btn btn_wide', this.report_type == 'SS'?'dark_blue':'']"
        >{{$t('site_report.site_shutdown')}}</b-button>
        </div>
      <div class="buttons">
        <b-button
          @click="setReportType('STC')" variant="white"
          :class="['btn btn_wide', this.report_type == 'STC'?'dark_blue':'']"
        >{{$t('site_report.sales_team_change')}}</b-button>
        <b-button
          class="ml-4"
          @click="setReportType('PC')" variant="white"
          :class="['btn btn_wide', this.report_type == 'PC'?'dark_blue':'']"
        >{{$t('site_report.price_change')}}</b-button>
      </div>
    </div>
    <div style="position: relative; width: 90%; margin: 0 auto">
      <b-form-textarea
        v-model="memo"
        rows="5"
        class="textarea_wrap textarea mt-1"
        :placeholder="$t('site_report.report_memo_placeholder')"
        style="height: 98px; margin: 0; width: calc(100% - 50px)"
      />
      <b-button
        class="btn btn_text btn_memo"
        @click="onShowImage"
        style="position: absolute; right: 0px; top: 0px"
      >보기</b-button>
      <b-button
        class="btn btn_text btn_memo dark_blue"
        @click="onAttachImage"
        style="position: absolute; right: 0px; top: 34px"
      >첨부</b-button>
      <input type="file" accept="image/*" @change="onImageChange" style="display: none" ref="img-file">
      <b-button
        class="btn btn_text btn_memo del_btn_color"
        @click="onRemoveImage"
        style="position: absolute; right: 0px; top: 68px"
      >삭제</b-button>
    </div>
    <p class="contentLabel" style="margin-top: 20px;">{{u.format($t('site_report.report_award'),1000)}}</p>
    <p class="contentLabel1" style="margin-top: 10px;">{{$t('site_report.report_award_bound')}}</p>
    <!--<p class="contentLabel2">{{$t('site_report.report_award_exception')}}</p>-->
    <p class="contentLabel2">{{$t('site_report.report_inaccurate_disadvantage')}}</p>
    <Gallery
      :visible.sync="galleryPopupShow"
      :src="memoImages"
      :current="0"
    />
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
import Gallery from "../Gallery.vue";

const $u = require('util');
export default {
  name: "SiteReportPopup",
  components: {Gallery},
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    item:{
      type:Object,
    },
    // site_name:{
    // type:String,
    // },
    // address:{
    //   type:String
    // },
  },
  data() {
    return {
      current:1,
      report_type: 'SC',
      u: $u,
      site_name:'',
      address:'',
      galleryPopupShow: false,
      memo:'',
      memoImages:[],
    }
  },
  methods:{
    setReportType(type){
      this.report_type = type;
    },
    onShow() {
      this.report_type = 'SC';
    },
    onOk(){
      Utils.showConfirm(this,"<p>"+`[${Utils.getReportTypeText(this.report_type)}] ${this.$t('site_report.ask_report')}`+"</p>"+
        "<p style='color:#cf0000;font-size: 20px;margin-bottom: 0;'>"+this.$t('site_report.report_inaccurate_disadvantage')+"</p>").then(
        value => {
          if (value){
            Utils.requestPost(
              this.$c.API.Site.reportSite,
              {
                site_idx: this.item.f_idx,
                report_type: this.report_type,
                complete_status: 'Y', // TODO: 정확한 분양완료상태
                memo: this.memo,
                memo_images: this.memoImages.length > 0 ? this.memoImages.join(',') : '',
              },
            ).then(result => {
              if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                Utils.toast(this, `[${Utils.getReportTypeText(this.report_type)}] ${this.$t('interest.report_confirm_click')}`);
              } else {
                Utils.toast(this, result.code === this.$c.API_RES_CODE.RESULT_ALREADY_EXIST ? this.$t('site_detail.already_reported_today') : result.msg);
              }
            });
          }
        }
      );

      this.$emit('update:visible', false);
    },
    onCancel(){
      this.$emit('update:visible', false);
    },

    onShowImage() {
      if (this.memoImages.length < 1) {
        Utils.toast(this, '첨부된 이미지가 없습니다.');
        return;
      }
      this.galleryPopupShow = true;
    },

    onAttachImage() {
      this.$refs["img-file"].click();
    },

    onRemoveImage() {
      if (this.memoImages.length < 1) {
        Utils.toast(this, '삭제할 이미지가 없습니다.');
        return;
      }
      Utils.showConfirm(this, '마지막 이미지가 삭제됩니다.').then(
        value => {
          if(value){
            this.memoImages.pop();
            Utils.toast(this, '삭제되었습니다.');
          }
        }
      )
    },

    onImageChange(){
      let file = this.$refs['img-file'].files[0];
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '2'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.memoImages.push(result.data.url);
          Utils.toast(this, '첨부되었습니다.');
        } else {
          // Utils.toast(this,result.msg);
          Utils.toast(this, '첨부되지 않았습니다. 다시 시도해주세요.');
        }
      });
    },
  },
  watch:{
    item(){
      if (this.item !== null){
        this.site_name = this.item.f_name;
        this.address = Utils.getAddress(this.item);
      }
    },
  },

}
</script>

<style lang="scss" scoped>
 @import "../../../assets/css/_vars.scss";

 .btn {
   display: flex;
   width: 88px;
   height: 46px;
   border-radius: 3px;
   justify-content: center;
   align-items: center;
   background-color: $c_cacbcd;
   color: $white;
   font-size: $fs_18;
   font-family: $korean_gd_15_r;
   padding: 0;
 }

 .btn_wide {width: 100px;}

 .buttons{
   margin: 10px auto;
   width: 90%;
   flex-wrap: wrap;
   display: flex;
   justify-content: center;
   align-items: center;
 }

.contentLabel{
   font-size: $fs_18;
   color: $c_457fff;
   text-align: center;
   font-family: $korean_gd_14_r;
   text-decoration: underline;
   line-height: 24px;
   margin-bottom: 0;
 };
 .contentLabel1{
   font-size: $fs_18;
   color: $c_457fff;
   text-align: center;
   font-family: $korean_gd_13_r;
   // line-height: 27;
 };
 .contentLabel2{
   font-size: $fs_20;
   color: #cf0000;
   text-align: center;
   font-family: $korean_gd_15_r;
   margin-bottom: 0;

 };

 .btn_text {
   padding: 0;
   width: 70px;
   height: 32px;
   align-items: center;
   justify-content: center;
   border-radius: 2px;
   background-color: $c_457fff;
   color: $white;
   font-size: $fs_14;
   font-family: $korean_gd_14_r;
   text-align: center;
 }

 .textarea_wrap {
   margin: 0 8px;
   border: solid 1px #dbd8d8;
   border-radius: 5px;
 }

 .textarea {
   color: $black;
   font-size: $fs_16;
   font-family: $korean_gd_13_r;
   padding: 12px 9px;
   line-height: 28px;
   margin-bottom: 0;
   white-space: break-spaces;
 }

 .btn_memo {
   width: 40px;
   height: 30px;
 }

 .dark_blue {background-color: #0840ba}
 .del_btn_color { background-color: #999999!important; }
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/SiteReportPopup.vue